import { render, staticRenderFns } from "./QuestionTypeMultipleChoice.vue?vue&type=template&id=24a94d1e"
import script from "./QuestionTypeMultipleChoice.vue?vue&type=script&lang=js"
export * from "./QuestionTypeMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeMultipleChoice.vue?vue&type=style&index=0&id=24a94d1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports